import axios from "../lib/axios";

/**
 * Create a new designation
 */
export const createDesignation = async (data) => {
  try {
    const response = await axios.post("/designation/add", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create designation"
    );
  }
};

/**
 * Get all designations
 */
export const getAllDesignations = async (lastId, limit = 20) => {
  try {
    const params = { limit };
    if (lastId) params.lastId = lastId;

    const response = await axios.get("/designation/all", { params });
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch designations"
    );
  }
};

/**
 * Update a designation
 */
export const updateDesignation = async (data) => {
  try {
    const response = await axios.put("/designation/update", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update designation"
    );
  }
};

/**
 * Delete a designation by ID
 */
export const deleteDesignation = async (id) => {
  try {
    const response = await axios.delete(`/designation/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete designation"
    );
  }
};
